
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/[id]",
      function () {
        return require("private-next-pages/about-us/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/[id]"])
      });
    }
  